// extracted by css-extract-rspack-plugin
export default {"widget":"xv9Nx","container":"Ug9AA","inputContainer":"xtvF8"};